import axios from 'axios';
import { constants } from './constants';
import history from '@history';
import moment from 'moment-timezone';

const client = axios.create({
  baseURL: constants.URLLOCAL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30000,
});

client.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.common['token'] = localStorage.getItem('token');
    config.headers.common['timezone'] = moment.tz.guess(true);
    // console.log(config)
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => {
    if (response.data == 'Token Not Found') {
      localStorage.removeItem('token');
      history.push({ pathname: '/' });
      // Reject explicitly so sagas/consumers don't receive undefined
      return Promise.reject(new Error('Session expired'));
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      history.push({ pathname: '/' });
    }
    return Promise.reject(error);
  }
);

client.defaults.headers.common['token'] = localStorage.getItem('token');

export default client;
